<template>
  <div class="dashboard-pie-chart-container">
    <div class="chart-title">{{ $t('dashboard.bookingSource') }}</div>
    <Skeleton v-if="chartLoading" width="100%" height="220px" />
    <Chart
      v-else-if="hasChartData"
      type="pie"
      :data="pieChartData"
      :options="pieChartOptions"
      style="width: 100%; height: 300px"
    />
    <div v-else class="no-chart-data">{{ $t('dashboard.noBookingSourceData') }}</div>
  </div>
</template>
<script setup>
import { computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Chart from "primevue/chart";
import Skeleton from "primevue/skeleton";
const props = defineProps({ filter: Object });
const { t } = useI18n();
const store = useStore();
const bookingSourceStats = computed(
  () =>
    store.getters["dashboard/getBookingSourceStats"] || {
      appBookings: 0,
      companyBookings: 0,
    }
);
const chartLoading = computed(() => !bookingSourceStats.value?.data);
const hasChartData = computed(() => {
  const d = bookingSourceStats.value?.data;
  return d && (d.appBookings > 0 || d.companyBookings > 0);
});
const pieChartData = computed(() => ({
  labels: [t('dashboard.appBookings'), t('dashboard.companyBookings')],
  datasets: [
    {
      data: [
        bookingSourceStats.value.data?.appBookings ?? 0,
        bookingSourceStats.value.data?.companyBookings ?? 0,
      ],
      backgroundColor: ["#6366f1", "#10b981"],
      borderColor: "#fff",
      borderWidth: 2,
    },
  ],
}));
const pieChartOptions = {
  plugins: {
    legend: {
      labels: {
        color: "#232946",
        font: { size: 14, weight: "bold" },
      },
      position: "bottom", // Move legend below the chart
      align: "center",
    },
  },
};
function fetchBookingSourceStats() {
  store.dispatch("dashboard/fetchBookingSourceStats", props.filter);
}
watch(() => props.filter, fetchBookingSourceStats, {
  immediate: true,
  deep: true,
});
</script>
<style scoped>
.dashboard-pie-chart-container {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  min-width: 0;
}
.chart-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2563eb;
  margin-bottom: 0.7rem;
  text-align: left;
  width: 100%;
  letter-spacing: 0.5px;
  padding-left: 0.2rem;
  align-self: flex-start;
}
.no-chart-data {
  width: 100%;
  text-align: center;
  color: #888;
  font-size: 1.1rem;
  padding: 2.5rem 0;
}
:deep(.p-chart .p-chart-legend) {
  margin-top: 1.5rem !important;
  justify-content: center !important;
  display: flex !important;
}
</style>
